var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.text && _vm.message.type === 'human') ? _c('div', {
    staticClass: "message-text"
  }, [_vm._v("\n  " + _vm._s(_vm.message.text) + "\n")]) : (_vm.message.text && _vm.shouldRenderAsHtml) ? _c('div', {
    staticClass: "message-text",
    domProps: {
      "innerHTML": _vm._s(_vm.botMessageAsHtml)
    }
  }) : (_vm.message.text && _vm.message.type === 'bot') ? _c('div', {
    staticClass: "message-text"
  }, [_vm._v("\n  " + _vm._s((_vm.shouldStripTags) ? _vm.stripTagsFromMessage(_vm.message.text) : _vm.message.text) + "\n")]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d69cb2c8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageText.vue
// module id = 167
// module chunks = 1